import PublicFeedback360 from "./PublicFeedback360";


export function Feedback360PrivateWrap() {

    return (
        <div className="flex w-full justify-center">
            <div className="flex w-full md:mt-4 sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/3">
                <PublicFeedback360/>
            </div>
        </div>
    )


}